import script from "./HrExpansionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HrExpansionItem.vue?vue&type=script&setup=true&lang=js"

import "./HrExpansionItem.vue?vue&type=style&index=0&id=2b923277&lang=scss&scoped=true"
import "./HrExpansionItem.vue?vue&type=style&index=1&id=2b923277&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b923277"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItem,QList});
